fragment CompanyFull on Company {
  cin
  name
  vat
}
